import {
  LBAlertDialog,
  LBAlertDialogAction,
  LBAlertDialogCancel,
  LBAlertDialogContent,
  LBAlertDialogDescription,
  LBAlertDialogFooter,
  LBAlertDialogHeader,
  LBAlertDialogTitle,
  LBAlertDialogTrigger,
  LBButton
} from '@linearb/buzz';
import { Tooltip } from '@material-ui/core';

const ReauthConfirmationButton = ({
  onReauth,
  text = 'Reauthorize',
  sensorName,
  tooltipText
}) => {
  return (
    <LBAlertDialog>
      <LBAlertDialogTrigger>
        <Tooltip
          title={tooltipText}
          placement='top'
          disableHoverListener={!tooltipText}
        >
          <LBButton variant='outline'>{text}</LBButton>
        </Tooltip>
      </LBAlertDialogTrigger>
      <LBAlertDialogContent className='min-w-[40rem] max-w-[50rem]'>
        <LBAlertDialogHeader>
          <LBAlertDialogTitle>{text}</LBAlertDialogTitle>
          <LBAlertDialogDescription>
            <div className='flex flex-col'>
              <div className='mb-4'>
                Reauthorizing will refresh the connection to{' '}
                {sensorName || 'the provider'}.
              </div>
              <div className=''>
                If a different user account is used, it may:
                <ul className='ml-4 list-inside list-disc'>
                  <li>Replace current access tokens</li>
                  <li>Change project/issue visibility</li>
                  <li>
                    Disrupt existing workflows tied to the original account
                  </li>
                </ul>
              </div>
            </div>
          </LBAlertDialogDescription>
        </LBAlertDialogHeader>
        <LBAlertDialogFooter>
          <LBAlertDialogCancel>Cancel</LBAlertDialogCancel>
          <LBAlertDialogAction onClick={onReauth}>Continue</LBAlertDialogAction>
        </LBAlertDialogFooter>
      </LBAlertDialogContent>
    </LBAlertDialog>
  );
};

export default ReauthConfirmationButton;
